/**
 * src/lib/pricing.js — centralized pricing engine (Kalki Ai Cloud).
 * Single source of truth for every White-Label price shown on the
 * marketing site. Amounts here MUST match the Stripe Price IDs in
 * backend/.env (WL_QUARTERLY_PRICE_ID / WL_HALFYEARLY_PRICE_ID /
 * WL_ANNUAL_PRICE_ID).
 */
export const WL_PLANS = [
  {
    id: 'quarterly',
    short: 'Quarterly',
    label: 'White-Label Quarterly',
    price_usd: 25000,
    amount_cents: 2500000,
    period: '/ 3 mo',
    duration: '3 Months License',
    tagline: 'Launch fast',
    highlight: false,
    save: null,
  },
  {
    id: 'halfyearly',
    short: 'Half-Yearly',
    label: 'White-Label Half-Yearly',
    price_usd: 40000,
    amount_cents: 4000000,
    period: '/ 6 mo',
    duration: '6 Months License',
    tagline: 'Most popular',
    highlight: true,
    save: null,
  },
  {
    id: 'annual',
    short: 'Annual',
    label: 'White-Label Annual',
    price_usd: 60000,
    amount_cents: 6000000,
    period: '/ year',
    duration: '12 Months License',
    tagline: 'Best value',
    highlight: false,
    save: null,
  },
]

export const WL_PLAN_BY_ID = Object.fromEntries(WL_PLANS.map((p) => [p.id, p]))

// Included with every licence — the 12 platform modules.
export const WL_BENEFITS = {
  items: [
    'AI Mentor with RAG',
    'Trading Terminal',
    'Strategy Builder',
    'Backtesting Suite',
    'Market Scanner',
    'Portfolio Analytics',
    'Trading Academy',
    'CRM',
    'Billing & Subscriptions',
    'Notifications',
    'Multi-Tenant Admin',
    'Custom Domain + SSL',
  ],
}

export const fmtUsd = (cents) => `$${Math.round(Number(cents || 0) / 100).toLocaleString('en-US')}`
